import { ReactNode } from 'react';
import { cn } from 'src/lib/utils';

export const ToolBarMenuButton = ({
  onPress,
  disabled,
  ...props
}: {
  children: ReactNode;
  disabled?: boolean;
  onPress?: () => void;
  onClick?: () => void;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) => (
  <button
    className={cn(
      'border-none rounded-sm cursor-pointer py-1 px-2 bg-transparent',
      !disabled && 'hover:bg-gray-200',
    )}
    disabled={disabled}
    onClick={onPress ?? props.onClick}
    {...props}
  ></button>
);
